let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fjuAD")).then(() => parcelRequire('hKJ3E'));